import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fraud_detection_changes_after_approval'),
    subtitle: defineMessage('what_changes_made_in_ne__company_administrators'),
    optionEmployee: defineMessage('employee'),
    optionTotalAmount: defineMessage('total_amount_more_than_companycurrencycode_change'),
    optionDate: defineMessage('date'),
    optionPurpose: defineMessage('purpose'),
    optionExpenseAccount: defineMessage('expense_account'),
    optionCategory: defineMessage('category'),
};
